import { render, staticRenderFns } from "./RegistConfirm.vue?vue&type=template&id=27b4c32a&scoped=true&lang=pug&"
import script from "./RegistConfirm.vue?vue&type=script&lang=js&"
export * from "./RegistConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RegistConfirm.vue?vue&type=style&index=0&id=27b4c32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b4c32a",
  null
  
)

export default component.exports